import { useCallback } from 'react';

export const useDownloadFeedback = (token: string) => {
  const handleDownloadReport = useCallback(() => {
    if (!token) {
      return;
    }

    try {
      const downloadUrl = `/api/v1/files/review/${token}/report`;
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `feedback-report_${token}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Failed to initiate report download:', error);
    }
  }, [token]);

  return handleDownloadReport;
};
